module.exports = __webpack_public_path__ + "static/media/checkmark.67e3a2c7.svg";